import React from 'react'

export const InvoiceDetailPage = React.lazy(() => import('./invoice-detail.page'))
